<!--  -->
<template>
  <div class="contaniner">
    <banner :type="type" :poster="poster" :currentTag="currentTag"></banner>
    <div class="recruit-content-box">
      <div class="top-wrapper">
        <div class="head-title">{{jobInfo.jobTitle}}</div>
        <div class="head-desc">
           <div class="deatil-desc">发布时间：{{jobInfo.lastOnlineTime}}</div>
           <div class="deatil-desc">职位类型: {{jobInfo.jobTitle}}</div>
           <div class="deatil-desc">招聘人数：{{jobInfo.number}}</div>
        </div>
      </div>
      <div class="main-wrapper" v-html="jobInfo.content"></div>
      <route-btn :prevId="navBtn.prev.id" :prevTitle="navBtn.prev.title" :nextId="navBtn.next.id" :nextTitle="navBtn.next.title" :routerName="navBtn.routerName"></route-btn>
    </div>
    <msg-box></msg-box>
    <top-arrow></top-arrow>
    <moni-footer></moni-footer>
  </div>
</template>

<script>
import banner from '../../components/banner/banner'
import moniFooter from '../../components/moniFooter/moniFooter'
import msgBox from '../../components/msgBox/msgBox'
import topArrow from '../../components/topArrow/topArrow'
import routeBtn from '../../components/routeBtn/routeBtn'
import http from '../../api/http.js'
import apiUrl from '../../api/apiUrl.js'
import util from '../../api/util.js'
import 'jquery'

export default {
  name: 'newsPage',
  data () {
    return {
      type: 'poster',
      poster: require('../../assets/images/banner4.png'),
      jHtml:  '<div><h3>工作职责:</h3><ul><li>1.根据产品需求设计文档，负责完成符合各项规范,满足功能需求的开发任务。</li><li>2.维护现有项目和修复程序bug。</li></ul></div><div><h3>岗位要求:</h3><ul><li>1.2年以上java开发经验,java基础扎实，熟悉常用的设计模式，有过分布式系统开发经验优先</li><li>2.熟悉Nginx,Redis，Mysql，spring，springboot，mybatis等常用的第三方框架，熟悉使用项目构建工具，如gradlemaven和开发工具interlljIDEA。</li><li>3.喜欢吃饭。</li><li>4.熟悉linux操作系统和常用的命令，对前端技术有一定的了解，能够熟练使用js,jQuery,ajax,css,html,html5等前端技术。</li><li>5.具有强烈的工作责任心，工作主动积极，有良好的沟通能力和团队合作精神。</li></ul></div><div><h3>工作地址：</h3><ul><li>广州越秀区中山二路粤运大夏</li></ul></div>',
      navBtn: {
        routerName: 'JobPage',
        prev: {id: '', title: ''},
        next: {id: '', title: ''}
      },
      currentTag: -1,
      jobInfo: {}
    }
  },

  props: [],

  watch: {
      '$route' (to, from) {
        if (to.name == 'JobPage') {
          $('html,body').animate({scrollTop: 0}, 500)
          this.fetchJobDetailInfo();
        }
    }
  },

  components: {
    banner,
    moniFooter,
    routeBtn,
    msgBox,
    topArrow
  },

  computed: {},

  created () {
    $('html,body').animate({scrollTop: 0}, 500)
    this.fetchJobDetailInfo()
  },

  methods: {
    fetchJobDetailInfo() {
      const id = this.$route.query.jobId;
      http.get(apiUrl.recruitDetail + id)
        .then(response => {
         console.log(response);
         if (response.code == 0) {
          const data = response.data;
          data.lastOnlineTime = util.formatTime(data.lastOnlineTime);
          this.jobInfo = data;
          this.navBtn.prev.id = data.prevJobId;
          this.navBtn.prev.title = data.prevJobTitle? '上一个: ' + data.prevJobTitle : '';
          this.navBtn.next.id = data.nextJobId;
          this.navBtn.next.title = data.nextJobTitle? '下一个: ' +  data.nextJobTitle : '';
         }
      })
    }
  }
}

</script>
<style lang='scss'>
 .contaniner {
   .recruit-content-box {
     width: 100%;
     padding: 80px 350px 100px 350px;
     box-sizing: border-box;
     font-size: 20px;
     text-align: left;
     .top-wrapper {
        border-bottom: #ccc solid 2px;
        padding-bottom: 29px;
       .head-title {
         color: #333;
         font-size: 30px;
         line-height: 42px;
       }
       .head-desc {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        color: #999;
        font-size: 16px;
        line-height: 22px;
        .deatil-desc {
          display: inline-block\0;
          width: 33%\0;
          text-align: left\0;
        }
       }
     }
     .main-wrapper {
       font-size: 18px;
       line-height:  40px;
       div { 
         margin-bottom: 20px;
         h3 { font-size: 20px; line-height: 40px; color: #333;}   
      }

       padding: 30px 0;
       border-bottom: #ccc dashed 1px;
     }
     .nav-wrapper {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        line-height: 25px;
        color: #fbabc7;
     }
   }
 }
</style>


// WEBPACK FOOTER //
// src/pages/jobPage/jobPage.vue